import $ from 'jquery';


// WEBPACK FOOTER //
// ./app/assets/js/common.js